import { useMutation } from '@tanstack/react-query';
import { aivaApi } from 'src/services';
import { useCallListClient } from './useGetCallList';
import { Call } from 'src/models';
import { useCallDetailsClient } from './useGetCallDetails';

export type UseAssignCallParams = {
  callId: string;
  practitionerId: number;
};

export type UseAssignCallResponse = {
  call: Call;
};

export const useAssignCall = () => {
  const { scanCall } = useCallListClient();
  const { updateCallDetails } = useCallDetailsClient();

  return useMutation({
    mutationKey: ['assignCall'],
    mutationFn: ({ callId, practitionerId }: UseAssignCallParams) =>
      aivaApi
        .put<UseAssignCallResponse>(`/call/${callId}/assign`, {
          practitioner_id: practitionerId,
        })
        .then((res) => res.data.call),
    onSuccess: (call, { callId }) => {
      scanCall(callId, () => call);
      updateCallDetails(call);
    },
  });
};
